import {FeatureFlag} from "../types/domain/featureFlag";
import {FeatureFlagStrategy} from "../types/domain/featureFlagStrategy";
import {handleAxiosError} from "./axiosErrorHandler";
import apiClient from "./baseService";

export const getFeatureFlags = async (): Promise<FeatureFlag[]> =>
    await apiClient
        .get<FeatureFlag[]>(`/featureflags`)
        .then((response) => response.data.sort((a, b) => a.name.localeCompare(b.name)))
        .catch(handleAxiosError);

export const postFeatureFlag = async (data: {name: string; description: string}) =>
    await apiClient
        .post<FeatureFlag>(`/featureflags`, data)
        .then((response) => response)
        .catch(handleAxiosError);

export const getFeatureFlagStrategies = async (id: string): Promise<FeatureFlagStrategy[]> =>
    await apiClient
        .get<FeatureFlagStrategy[]>(`/featureflags/${id}/strategies`)
        .then((response) => response.data)
        .catch(handleAxiosError);

export const postFeatureFlagStrategy = async ({
    featureFlagId,
    data,
}: {
    featureFlagId: string;
    data: Partial<FeatureFlagStrategy>;
}) =>
    await apiClient
        .post<FeatureFlag>(`/featureflags/${featureFlagId}/strategies`, data)
        .then((response) => response)
        .catch(handleAxiosError);

export const getCompanyFeatureFlags = async (companyId: string) =>
    await apiClient
        .get<Record<string, boolean>>(`/companies/${companyId}/featureflags`)
        .then((response) => response.data)
        .catch(handleAxiosError);
